import { formatDateReadable } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';

export const GridDateTime = ({ value }: { value: Date }) => {
  const dateString = formatDateReadable(value);
  const timeString = value.toLocaleTimeString();

  return (
    <div
      style={{
        lineHeight: 1.3,
        textAlign: 'right',
      }}
    >
      <div>{dateString}</div>
      <Font variant="caption" color="textSecondary">
        {timeString}
      </Font>
    </div>
  );
};
